// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__fXg7f","inputField":"Search_inputField__+wGIv","darkMode":"Search_darkMode__xEiGr"};